import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const clientPlanAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'clientAPI',
    endpoints: (builder) => ({

        addClientPlan: builder.mutation({
            query: (data) => ({
                url: `/ClientPlan/AddClientPlan`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateClientPlan: builder.mutation({
            query: (data) => ({
                url: `/ClientPlan/UpdateClientPlan`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getClientPlanListById: builder.mutation({
            query: (clientID) => ({
                url: `/ClientPlan/GetClientPlanById?ClientID=${clientID}`,
                method: `POST`,
                body: transformRequest(clientID)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteClientPlan: builder.mutation({
            query: (planID) => ({
                url: `/ClientPlan/DeleteClientPlan?PlanID=${planID}`,
                method: `DELETE`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        })

    })
});

export const { 
    useAddClientPlanMutation, 
    useUpdateClientPlanMutation, 
    useGetClientPlanListByIdMutation, 
    useDeleteClientPlanMutation,
     } = clientPlanAPI;

export default clientPlanAPI;